module.exports = __webpack_public_path__ + "static/media/coelacanth.81070e79.png";